import { render, staticRenderFns } from "./homeSettings.vue?vue&type=template&id=16aea2c8&scoped=true"
var script = {}
import style0 from "./homeSettings.vue?vue&type=style&index=0&id=16aea2c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16aea2c8",
  null
  
)

export default component.exports